import { render, staticRenderFns } from "./HistoricoMensagensAnteriores.vue?vue&type=template&id=18baeeb6&scoped=true&"
import script from "./HistoricoMensagensAnteriores.vue?vue&type=script&lang=js&"
export * from "./HistoricoMensagensAnteriores.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoMensagensAnteriores.vue?vue&type=style&index=0&id=18baeeb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18baeeb6",
  null
  
)

export default component.exports